<div class="container col-md-12">
    <div class="">
        <div class="d-flex justify-content-between mb-5">
            <h1 class="page col-md-6 mb-4">Demo Requests</h1>
        </div>
    </div>
    <div class="d-flex justify-content-between mt-5 laptop">
        <div class="position-relative col-md-3">
            <!--  -->
            <input type="text" class="form-control search-input" [formControl]="search_data" placeholder="Search...." (keydown.enter)="search_submit()">
            <span class="ri-search-line search-icon"></span>
        </div>

        <div class="border text-whhite d-flex justify-content-end page-top" *ngIf="searchchar === false">
            <mat-paginator class="bg-transparent" [hidden]="apiData?.length==0" [length]="this.length" [pageSizeOptions]="[10, 25, 50]" [(pageSize)]="paginate.pageSize" (page)="fetchData($event)"></mat-paginator>
        </div>
    </div>
    <div class="row d-flex justify-content-center p-4">
        <div class="card-body" style="background-color:transparent;">
            <div class="material-datatables">
                <div class="position-relative overflow-auto">
                    <table class="table table-no-bordered table-hover" mat-table [dataSource]="customers" matSort>
                        <ng-container [matColumnDef]="tableheader" *ngFor="let tableheader of displayedColumns; index as i" [stickyEnd]="tableheader == 'actions'">

                            <ng-container *ngIf="tableheader=='actions'">
                                <td mat-cell class=" " *matCellDef="let row; index as i" style="font-size: 12px;">
                                    <div class="d-flex">
                                        <button class="btn btn-primary btn-sm ms-2" (click)="openupdateform(updateticket,row)">Edit</button>
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container *ngIf="tableheader !== 'ticket_id' && tableheader !== 'image1' && tableheader !== 'image2'">
                                <th mat-header-cell *matHeaderCellDef class="text-center text-primary text-bold" mat-sort-header style="white-space: nowrap;">
                                    {{ headerData[tableheader] }}
                                </th>
                                <td mat-cell class="text-center align-middle" style="white-space: nowrap; font-size: 12px;" *matCellDef="let row; index as i">
                                    <span>{{ row[tableheader] }}</span>
                                </td>
                            </ng-container>
                        </ng-container>




                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                    </table>
                </div>
            </div>
            <div class="border text-whhite d-flex justify-content-end page-bottom">
                <mat-paginator class="bg-transparent" [hidden]="apiData?.length==0" [length]="fulllength" [pageSizeOptions]="[10, 25, 50]" [(pageSize)]="paginate.pageSize" (page)="fetchData($event)"></mat-paginator>
            </div>
        </div>
    </div>
</div>


<ng-template #updateticket let-modal>
    <div class="col-md-12 p-4">
        <div class="d-flex justify-content-between align-items-center mb-3">
            <h5>Update Tickets</h5>
            <button class="btn btn-sm btn-danger" (click)="modal.dismiss()">Close</button>
        </div>

        <form [formGroup]="updateform" (ngSubmit)="onSubmit()">
            <!-- Row 1 -->
            <div class="d-flex mb-3">
                <mat-form-field appearance="outline" class="flex-fill me-2">
                    <mat-label>First Name</mat-label>
                    <input matInput formControlName="first_name">
                </mat-form-field>

                <mat-form-field appearance="outline" class="flex-fill">
                    <mat-label>Last Name</mat-label>
                    <input matInput formControlName="last_name">
                </mat-form-field>
            </div>

            <!-- Row 2 -->
            <div class="d-flex mb-3">
                <mat-form-field appearance="outline" class="flex-fill me-2">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="email">
                </mat-form-field>

                <mat-form-field appearance="outline" class="flex-fill">
                    <mat-label>Phone</mat-label>
                    <input matInput formControlName="phone">
                </mat-form-field>
            </div>

            <!-- Row 3 -->
            <div class="d-flex mb-3">
                <mat-form-field appearance="outline" class="flex-fill me-2">
                    <mat-label>Message</mat-label>
                    <input matInput formControlName="message">
                </mat-form-field>

                <mat-form-field appearance="outline" class="flex-fill me-2">
                    <mat-label>Ticket Status</mat-label>
                    <mat-select formControlName="ticket_status" panelClass="select-in-modal">
                        <mat-option value="open">Open</mat-option>
                        <mat-option value="close">Close</mat-option>
                    </mat-select>
                </mat-form-field>

            </div>

            <!-- Row 4 (Dropdowns) -->
            <div class="d-flex mb-3">
                <mat-form-field appearance="outline" class="flex-fill me-2">
                    <mat-label>Is Responded</mat-label>
                    <mat-select formControlName="is_responded" panelClass="select-in-modal">
                        <mat-option [value]="true">True</mat-option>
                        <mat-option [value]="false">False</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="flex-fill">
                    <mat-label>Respond Method</mat-label>
                    <mat-select formControlName="respond_method" panelClass="select-in-modal">
                        <mat-option value="Mail">Mail</mat-option>
                        <mat-option value="Phone">Phone</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="d-flex justify-content-center gap-2">
                <button class="btn btn-sm btn-danger" (click)="close_dialog()">Cancel</button>
                <button class="btn btn-sm btn-success" type="submit">Update</button>
            </div>
        </form>
        <ng-container *ngIf="showOverlay" id="overlay-container">
            <app-spinner [overlay]="true" id="loader"></app-spinner>
        </ng-container>
    </div>
</ng-template>

<ng-container *ngIf="showOverlay" id="overlay-container">
    <app-spinner [overlay]="true" id="loader"></app-spinner>
</ng-container>